export enum ConnectClaim {
  Role = 'extension_connect_role',
  AccountId = 'extension_connect_account_id',
  GivenName = 'given_name',
  FamilyName = 'family_name',
  CompleteName = 'name',
  Emails = 'emails',
  UserId = 'extension_connect_user_id',
  IsPlatformAdmin = 'extension_connect_is_platform_admin',
  UserStatus = 'extension_connect_user_status',
}
